// ABOUTME: useHorizon is the single source of the horizon's y on a deck step, and of the viewport height the deck fit needs.
// ABOUTME: SceneHost supplies the screen id through HorizonScreenContext; the phone layout is the Crossing's under 760px.

import { createContext, useContext, useEffect, useState } from 'react';
import { usePhoneLayout } from '../runner/usePhoneLayout';
import { HEADER_HEIGHT_PX, horizonFor } from './horizon';

export const HorizonScreenContext = createContext<string | undefined>(undefined);

function useViewportHeight(): number {
  const [height, setHeight] = useState(() => window.innerHeight);
  useEffect(() => {
    const onResize = () => setHeight(window.innerHeight);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  return height;
}

export interface Horizon {
  frameH: number;
  phone: boolean;
  /** From the header's bottom edge. */
  hz: number;
  /** The line's top in the viewport: the header plus hz. */
  line: number;
}

export function useHorizon(): Horizon {
  const screenId = useContext(HorizonScreenContext);
  const frameH = useViewportHeight();
  const phone = usePhoneLayout();
  const hz = horizonFor(screenId, phone, frameH);
  return { frameH, phone, hz, line: HEADER_HEIGHT_PX + hz };
}
